import { Component, Input } from '@angular/core';

@Component({
  selector: 'love-icon',
  templateUrl: 'love-icon.html'
})
export class LoveIconComponent {
  @Input() width: string;
  @Input() height: string;
  constructor() {
    if (!this.width) {
      this.width = '16';
    }
    if (!this.height) {
      this.height = '16';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/love-icon/love-icon.ts